<template>
    <span>{{ displayName }}</span>
</template>

<script>

import userMixin from '../mixins/userMixin';

export default {
    mixins: [userMixin],

    props: {
        'firstNameOnly': {
            type: Boolean,
            default: false
        }
    },

    computed: {
        displayName() {
            return this.firstNameOnly ? this.firstName : this.name;
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/UserName.vue